import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {dispatchAsync} from 'redux/common';
import {asyncType} from 'redux/helpers';
import {DialogCallbacks} from 'types/common';
import ApiService from 'api/ApiService';
import useIsMountedRef from './useIsMountedRef';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';

/**
 *
 * @param url
 * @param type
 * @param options
 */
export const usePostApiDispatch = (
   url: string,
   type: ReturnType<typeof asyncType>,
   options?: DialogCallbacks & {data?: any}
) => {
   const isMountedRef = useIsMountedRef();
   const dispatch = useDispatch();
   return useCallback(
      (data?: any, formikHelpers?: FormOnSubmitHelpers<any>) => {
         dispatch(
            dispatchAsync(url, type, {
               getMethod: ApiService.postSecureJson,
               onSuccess: (data, dispatch) => {
                  if (!isMountedRef.current) return;

                  formikHelpers?.setSubmitting(false);
                  if (options && options.onSuccess) {
                     options.onSuccess(data, dispatch);
                  }
               },
               onError: (data, dispatch) => {
                  if (!isMountedRef.current) return;

                  formikHelpers?.setSubmitting(false);
                  formikHelpers?.setErrors(data);
                  if (options && options.onError) {
                     options.onError(data, dispatch);
                  }
               },
               data: data || options?.data,
            })
         );
      },
      [dispatch, url, type, options, isMountedRef]
   );
};
